import {
  PLAID_LINK_TOKEN_DESER,
  PLATFORM_NAMES,
  PlaidLinkToken,
} from "../../tastyworks/cash-management"
import { CUSTOMER_DESER, Customer } from "../../tastyworks/customer"
import type HttpClient from "../../tastyworks/http"
import {
  type SingleResponse,
  updateSingleResponse,
} from "../../tastyworks/response"

export class PlaidLayerService {
  private readonly customersClient: HttpClient

  constructor(baseHttpClient: HttpClient) {
    this.customersClient = baseHttpClient.nested("customers")
  }

  readonly createLinkToken = async (): Promise<
    SingleResponse<PlaidLinkToken>
  > => {
    const helper = await this.customersClient.postJson("identity-link-token", {
      "platform-name": PLATFORM_NAMES.WEB,
    })
    return updateSingleResponse(
      helper,
      new PlaidLinkToken(),
      PLAID_LINK_TOKEN_DESER.update
    )
  }

  readonly exchangeIdentity = async (
    publicToken: string
  ): Promise<SingleResponse<Customer>> => {
    const helper = await this.customersClient.postJson("identity-details", {
      "public-token": publicToken,
    })
    return updateSingleResponse(helper, new Customer(), CUSTOMER_DESER.update)
  }
}
